module.exports = __webpack_public_path__ + "img/wzy.18270cc5.png";